import { gql } from '@apollo/client';

export const DOCUMENT_UPDATED = gql`
  subscription documentUpdated($documentId: Int!, $siteId: Int!, $userId: Int!) {
    documentUpdated(documentId: $documentId, siteId: $siteId, userId: $userId) {
      documentId
      siteId
    }
  }
`;

export const DOCUMENTS_COMPUTED = gql`
  subscription documentsComputed($documentId: Int!, $siteId: Int!) {
    documentsComputed(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;
